import { FC } from "preact/compat";
import { useApp } from "~/core";
import { Button } from "~/components";
import { ToolbarProps } from "./interfaces";
import HistoryIcon from "@material-design-icons/svg/outlined/history.svg";
import cn from "classnames";

const Toolbar: FC<ToolbarProps> = ({ active }) => {
    const { help } = useApp();

    if (!active) {
        return <div />;
    }

    return (
        <div className="flex items-center gap-x-2">
            <Button
                size="sm"
                onClick={() =>
                    (help.admin.isEditorHistory.value =
                        !help.admin.isEditorHistory.peek())
                }
                className={cn(
                    "gap-x-2",
                    help.admin.isEditorHistory.value &&
                        "!border-sky-500 !text-sky-500",
                )}
            >
                <HistoryIcon width="16" height="16" />
                <span>View History</span>
            </Button>
        </div>
    );
};

export default Toolbar;
